import {
  AudioWaveform,
  Banknote,
  Bell,
  Calendar,
  CalendarRange,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Command,
  FileSignature,
  FileText,
  GalleryVerticalEnd,
  Gavel,
  GitBranch,
  LayoutDashboard,
  LayoutTemplate,
  ListChecks,
  ListTodo,
  Network,
  TrendingUp,
  Users,
  Wallet,
} from "lucide-react";
import type { SidebarData } from "../types";

export const sidebarData: SidebarData = {
  teams: [
    {
      name: "Shadcn Admin",
      logo: Command,
      plan: "Vite + ShadcnUI",
    },
    {
      name: "Acme Inc",
      logo: GalleryVerticalEnd,
      plan: "Enterprise",
    },
    {
      name: "Acme Corp.",
      logo: AudioWaveform,
      plan: "Startup",
    },
  ],
  navGroups: [
    {
      title: "ທົ່ວໄປ",
      items: [
        {
          title: "ຂໍ້ມູນສ່ວນຕົວ",
          url: "/app/dashboard",
          icon: LayoutDashboard,
        },
        {
          title: "KPI ສ່ວນຕົວ",
          url: "/app/performance/kpi",
          icon: TrendingUp,
        },
        {
          title: "ວຽກທີ່ໄດ້ຮັບມອບໝາຍ",
          url: "/app/performance/tasks",
          icon: ListTodo,
        },
      ],
    },
    {
      title: "ເອກະສານຂອງຂ້ອຍ",
      items: [
        {
          title: "ລາຍການເອກະສານ",
          url: "/app/my-documents",
          icon: FileText,
        },
      ],
    },
    {
      title: "ບໍລິການ HR",
      items: [
        {
          title: "ຄຳຂໍລາ",
          url: "/app/hr/leave/requests",
          icon: Calendar,
        },
        {
          title: "ຄຳຂໍ OT",
          url: "/app/hr/overtime/requests",
          icon: Clock,
        },
        {
          title: "ເງິນເດືອນ",
          url: "/app/hr/payroll",
          icon: Wallet,
        },
        {
          title: "ເບິກເງິນເດືອນລ່ວງໜ້າ",
          url: "/app/hr/salary-advance/requests",
          icon: Banknote,
        },
        {
          title: "ໂຄງຮ່າງອົງກອນ",
          url: "/app/org-chart",
          icon: Network,
        },
      ],
    },
    {
      title: "ເອກະສານ",
      items: [
        {
          title: "ແບບຟອມ",
          url: "/app/documents/forms",
          icon: FileText,
        },
        {
          title: "ຮ່າງເອກະສານ",
          url: "/app/documents/templates",
          icon: LayoutTemplate,
        },
        {
          title: "ສັນຍາຂອງຂ້ອຍ",
          url: "/app/documents/contracts",
          icon: FileSignature,
        },
        {
          title: "ນະໂຍບາຍບໍລິສັດ",
          url: "/app/documents/policies",
          icon: Gavel,
        },
      ],
    },
    {
      title: "ການຝຶກອົບຮົມ",
      items: [
        {
          title: "ຂັ້ນຕອນການດຳເນີນງານ",
          url: "/app/training/sop",
          icon: FileText,
        },
        {
          title: "ແຜນ Flow ການເຮັດວຽກ",
          url: "/app/training/flows",
          icon: GitBranch,
        },
        {
          title: "ມາດຕະຖານບໍລິການ",
          url: "/app/training/standards",
          icon: ClipboardCheck,
        },
        {
          title: "ລາຍການກວດສອບ",
          url: "/app/training/checklists",
          icon: ListChecks,
        },
      ],
    },
    {
      title: "ການສື່ສານ",
      items: [
        {
          title: "ກອງປະຊຸມ",
          url: "/app/communication/meetings",
          icon: Users,
        },
        {
          title: "ບັນທຶກກອງປະຊຸມ",
          url: "/app/communication/minutes",
          icon: ClipboardList,
        },
        {
          title: "ປະຕິທິນວຽກ",
          url: "/app/communication/calendar",
          icon: CalendarRange,
        },
        {
          title: "ການແຈ້ງເຕືອນ",
          url: "/app/communication/notifications",
          icon: Bell,
        },
      ],
    },
  ],
};
